<template>
  <div class="dropDownMainContainer">
    <div class="dropDownWrapper" @click="toggleDropdown">
      <img :src="selectedFlag.flag" :alt="selectedFlag.code"/>
      <img src="/assets/images/svg/down-arrow.svg" class="transition" :style="isOpen ? 'transform: rotate(180deg)' : ''" alt=""/>
    </div>
    <div v-if="!hidden" ref="dropDownMenu" class="dropDownMenu transition">
      <div class="menuItem" :key="lang.code" v-for="lang in languages" @click="selectLanguage(lang)">
        <img class="flagImage" :src="lang.flag" :alt="lang.code"/>
        <span
          class="languageText"
          v-html="selectedLanguage === lang.code ? `<b>${lang.text}</b>` : lang.text"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "language-dropdown",
  props: {
    languages: {
      type: Array,
      required: true,
      default: () => [{ text: "English", code: "en", flag: "/assets/images/flags/england.svg" }]
    }
  },
  data: () => {
    return {
      selectedLanguage: "dk",
      isOpen: false,
      disabled: true, // to prevent misclicks while in the animation
      hidden: true
    }
  },
  computed: {
    selectedFlag () {
      return this.languages.find(el => el.code === this.selectedLanguage)
    }
  },
  beforeMount () {
    let lang = localStorage.getItem("lang");
    if (lang) this.selectedLanguage = lang
    else lang = this.selectedLanguage

    localStorage.setItem('lang', lang)
    this.$root.$i18n.locale = lang
    history.replaceState({}, null, '/' + lang + '/')
    this.$store.commit("setCampaignId", `oralb-moneyback-${lang}`)
  },
  methods: {
    toggleDropdown () {
      let dropDownMenu = this.$refs['dropDownMenu'];
      if (this.isOpen) { // if dd is open
        dropDownMenu.style.transform = "translate(0px, -70px)"
        dropDownMenu.style.opacity = "0"
        this.disabled = true;
        setTimeout(() => {
          this.hidden = true;
        }, 333);
      } else { // if dd is closed
        this.hidden = false;
        this.disabled = false;
        setTimeout(() => {
          dropDownMenu = this.$refs['dropDownMenu'];
          dropDownMenu.style.transform = "translate(0px, 0px)"
          dropDownMenu.style.opacity = "1"
        }, 0);
      }
      this.isOpen = !this.isOpen
    },
    selectLanguage (lang) {
        if (!this.disabled) {
          const acceptedCountryValues = {
        'se': {
          ConsentOverlayId: 'htmllang/0fad0e26-8097-439f-85cf-316d2a53811a',
          lang: 'sv-SE',
          langCode: 'SE',
          marketingProgramNbr: '410',
          sourceID: '14297'
        },
        'fi': {
          ConsentOverlayId: 'htmllang/f040ae65-47a0-491a-92ba-ee1548ba8df6',
          lang: 'fi-FI',
          langCode: 'FI',
          marketingProgramNbr: '517',
          sourceID: '14300'
        },
        'dk': {
          ConsentOverlayId: "htmllang/7571fd7f-262c-44cd-a9f7-cf411a3f853e",
          lang: 'da-DK',
          langCode: 'DK',
          marketingProgramNbr: '516',
          sourceID: '14298'
        },
        'no': {
          ConsentOverlayId: "htmllang/4b8cd85a-a1d6-49d0-a4ab-fb73c0b7a447",
          lang: 'no-NO',
          langCode: 'NO',
          marketingProgramNbr: '515',
          sourceID: '14299'
        }
      }
      const currentCountry = acceptedCountryValues[lang.code]
        window.PGdataLayer.GTM["SiteLocale"] = currentCountry.lang
        window.PGdataLayer.GTM["SiteCountry"] = lang.code.toUpperCase()
        window.PGdataLayer.GTM["SiteLanguage"] = currentCountry.langCode
        window.PGdataLayer.GTM["ConsentOverlayID"] = currentCountry.ConsentOverlayId
        window.PGdataLayer.user = { "id": "", "marketingProgramNbr": currentCountry.marketingProgramNbr, "sourceID": currentCountry.sourceID };
        this.selectedLanguage = lang.code
        localStorage.setItem("lang", this.selectedLanguage)
        this.$root.$i18n.locale = this.selectedLanguage
        history.replaceState({}, null, '/' + lang.code + '/')
        this.$store.commit("setCampaignId", `oralb-moneyback-${lang.code}`)
        this.toggleDropdown()
        window.location.reload();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.dropDownMainContainer {
  position: relative;
  margin: 0 10px;
  order: -1;
  @media (max-width: 350px) {
    margin: 0;
  }
}
.dropDownWrapper {
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 65px;
  max-height: 36px;
  background: #FFFFFF;
  border-radius: 4px;
  transition: all .3s;

  &:hover {
    cursor: pointer;
    box-shadow: 0px 8px 16px -4px #EBEBEB;
  }
}

.dropDownMenu {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0;
  background: #fff;
  opacity: 0;
  transform: translate(0, -70px);
  border-radius: 4px;
  margin-top: 10px;
  width: 153px;
  box-shadow: 0px 8px 16px -4px rgb(204, 204, 204);
  z-index: 1;

  .menuItem {
    background: #fff;
    width: 90%;
    padding: 4px 8px 4px 8px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #F7F7F7;

    &:first-child {
      margin-top: 8px;
    }

    &:last-child {
      border: none;
      margin-bottom: 8px;
    }
    .flagImage {
      margin-right: 10px;
    }

    .languageText {
      font-size: 14px;
    }

    &:hover {
        background: #F7F7F7;
    }
  }
}

.transition {
  transition: all 0.3s;
}
</style>
